import { mapBackgroundColor } from '@/helpers/mapBackgroundColor';
import { FC } from 'react';

export type PageBannerProps = {
  title: React.ReactNode;
  description: string | JSX.Element;
  descriptionTwo: string | JSX.Element;
  backgroundColor?: 'green' | 'violet' | 'pink';
  bannerImage: React.ReactNode;
  showNewTag: boolean;
}

const PageBanner: FC<PageBannerProps> = ({
  title,
  description,
  descriptionTwo,
  bannerImage,
  backgroundColor = 'pink',
  showNewTag = true,
}) => {

  const outerBackgroundColors = {
    pink: 'bg-pink-100',
    violet: 'bg-violet-100',
    green: 'bg-green-100',
  };

  const outerBackgroundColor = outerBackgroundColors[backgroundColor];
  const innerBackgroundColor = mapBackgroundColor(backgroundColor);

  return (
    <div className={`text-white ${outerBackgroundColor}`}>
      <div className="-mt-header-height-mobile md:-mt-header-height-desktop md:pt-header-height-desktop">
        <div className="pt-11 md:pt-12 px-container-mobile md:px-container-desktop pb-[200px]">
          <div className="grid gap-2 md:gap-3 text-left mx-auto max-w-grid">
            <div
              className={`flex flex-wrap md:flex-nowrap flex-col-reverse md:flex-row justify-left rounded-[16px] items-center ${innerBackgroundColor}`}
            >
              <div className="flex w-full md:w-[45%] justify-center py-5 md:p-8">
                {bannerImage}
              </div>
              <div className="flex w-full md:w-[55%] h-auto md:h-[100%] relative">
                <div className="flex flex-wrap w-full items-center">
                  <div className="flex flex-wrap mr-[20px] ml-[20px] md:mx-8">
                    {showNewTag && (
                      <div className="text-blue-900 uppercase text-14.5/22 bg-citron-500 rounded-[4px] p-[4px] font-500 mb-[18px] mt-[36px] md:mt-0">
                        new
                      </div>)
                    }
                    <h3 className="font-500 text-36/44 text-white mb-[9px] w-full">{title}</h3>
                    <div className="flex text-white text-17/25">
                      {description}
                      <br />
                      {descriptionTwo}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageBanner;
